/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Transition from '@ember/routing/transition';
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';

export default class SecurityModelsDataSharingRoute extends WorkspaceSettingsRoute {
  @service declare appService: AppService;
  @service declare store: any;
  @service declare intl: IntlService;
  @service declare router: any;
  @service declare permissionsService: any;

  analytics = {
    section: 'new_settings',
    place: 'security_models_data_sharing',
  };

  get titleToken() {
    return this.intl.t(`new-settings.submenu.workspace.security-models-data-sharing`);
  }

  beforeModel(transition: Transition) {
    super.beforeModel(transition);

    this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_workspace_settings',
      transition,
    );

    if (!this.appService.app.canUseModelsDataSharingOptOut) {
      this.router.replaceWith('apps.app.settings.workspace.security');
    }
  }

  async model() {
    try {
      let records = await this.store.query('model-training-consent-opt-out-request', {
        app_id: this.appService.app.id,
      });

      if (records.length > 0) {
        return records.firstObject;
      } else {
        return this.store.createRecord('model-training-consent-opt-out-request', {
          approved: false,
          appId: this.appService.app.id,
        });
      }
    } catch (e) {
      return null;
    }
  }
}
